import {
  type EstimateLineItem,
  selectNodesBySection,
  selectSectionsByTab,
  selectTabNodes,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'

import {
  buildEstimateTreeNode,
  createNodeByIdMap,
  getRootNodeIds,
  getUniqueNodeIdsWithDescendants,
} from './helper/estimateTreeFactory'
import type { EstimateTreeColumns } from './types'

export const getEstimate = (
  state: AppState,
  lineItems: EstimateLineItem[]
): EstimateTreeColumns => {
  const activeTabId = migrationProjectSelector.getActiveOrFirstTabId(state)

  const nodeItems = selectTabNodes(activeTabId)({
    project: state.manager.project,
    relations: state.relations,
  })

  const nodeById = createNodeByIdMap(nodeItems)

  const sections = selectSectionsByTab(activeTabId)(state)

  return sections.map((sectionId) => {
    const sectionNodeIds = selectNodesBySection(sectionId)(state)
    const nodeIds = getUniqueNodeIdsWithDescendants(sectionNodeIds, state)
    const rootNodeIds = getRootNodeIds(nodeIds, state)

    return rootNodeIds.map((id) =>
      buildEstimateTreeNode(id, state, nodeById, lineItems)
    )
  })
}
